import styled from 'styled-components';
import * as tokens from 'styles';
import { media } from 'styles/mixins';

const SectionWrapper = styled.section`
  padding: ${tokens.spacer64} ${tokens.spacer24};
  background-color: ${props => props.theme.sectionBackground};
  color: ${props => props.theme.sectionForeground};

  ${media.mobileMdUp} {
    padding: ${tokens.spacer64} ${tokens.spacer48};
  }
`;

export default SectionWrapper;
